import { render, staticRenderFns } from "./ResourceFilter.vue?vue&type=template&id=2c10d8a1&scoped=true&"
import script from "./ResourceFilter.vue?vue&type=script&lang=js&"
export * from "./ResourceFilter.vue?vue&type=script&lang=js&"
import style0 from "./ResourceFilter.vue?vue&type=style&index=0&id=2c10d8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10d8a1",
  null
  
)

export default component.exports